export default function Logo() {
  return <h1>🏝️ Pack It 🧳</h1>;
}
